// Frontend status types (used in UI)
export type FrontendStatus = 'Active' | 'Inactive' | 'Pending' | 'Running' | 'Failed' | 'Completed';

// Backend status types (from API)
export type BackendRunStatus = 'running' | 'success' | 'failed' | 'queued' | 'scheduled';
export type BackendSourceStatus = 'active' | 'inactive' | 'pending';

/**
 * Map backend job run status to frontend display status
 * Used for individual job runs
 */
export function mapJobRunStatus(status: string): 'Running' | 'Failed' | 'Completed' {
    const statusLower = status?.toLowerCase();
    if (statusLower === 'failed') return 'Failed';
    if (statusLower === 'success') return 'Completed';
    return 'Running';
}

export function mapSourceStatus(sourceStatus: string, runStatus?: string): FrontendStatus {
    if (runStatus) {
        const runStatusLower = runStatus.toLowerCase();
        if (runStatusLower === 'running') return 'Running';
        if (runStatusLower === 'success') return 'Completed';
        if (runStatusLower === 'failed') return 'Failed';
    }

    const sourceStatusLower = sourceStatus?.toLowerCase();
    if (sourceStatusLower === 'active') return 'Active';
    if (sourceStatusLower === 'inactive') return 'Inactive';

    return 'Pending';
}

/**
 * Map frontend status to backend source status
 */
export function mapFrontendToBackendStatus(status: FrontendStatus): string {
    const statusMap: Record<FrontendStatus, string> = {
        Active: 'active',
        Inactive: 'inactive',
        Pending: 'pending',
        Running: 'running',
        Failed: 'failed',
        Completed: 'success',
    };
    return statusMap[status] || 'pending';
}

/**
 * Check if a status represents a terminal state (completed/failed)
 */
export function isTerminalStatus(status: string): boolean {
    const statusLower = status?.toLowerCase();
    return statusLower === 'success' || statusLower === 'failed' || statusLower === 'completed';
}

/**
 * Check if a status represents an active/running state
 */
export function isActiveStatus(status: string): boolean {
    const statusLower = status?.toLowerCase();
    return statusLower === 'running' || statusLower === 'active';
}
